import React from 'react';


interface StepCardProps {
  title: string;
  icon: JSX.Element;
  subtext: string;
  subtext2: string;
  isActive: boolean;
  isCompleted: boolean;
}

const StepCard: React.FC<StepCardProps> = ({ title, isActive, isCompleted, icon, subtext, subtext2 }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const cardStyles = {
    backgroundColor: isCompleted ? '#015CB5' : isActive ? '#E2FAFF' : isHovered ? '#E2FAFF' : '#FFFFFF',
    border: isCompleted ? '1px solid #015CB5' : isActive ? '1px solid #FF6702' : isHovered ? '1px solid #FF6702' : '1px solid transparent',
    color: isCompleted  ? '#FFFFFF' : '#000000',
  };

  return (
    <>
      <div className="my-2 p-4 rounded-md border-1.5 flex items-center gap-2 md:w-[290px] xl:w-[350px] biglg:w-[350px] lg:w-[350px]" style={cardStyles} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <div className="w-3/10">
          {React.cloneElement(icon, { isWhite: isCompleted  })} 
        </div>
        <div>
          <h3 className="font-semibold lg:text-[24px] md:text-[18px]">{title}</h3>
          <p className="lg:text-[14px] md:text-[11px]">{subtext}</p>
          <p className="lg:text-[14px] md:text-[11px]">{subtext2}</p>
        </div>
      </div>
      <hr className="border-t-1 w-[350px]" />
    </>
  );
};

export default StepCard;
